import React from 'react';
import { get, post, put, del, patch } from '../../../../Utility/Http';
import { updateProfessionalDetailsUpdateApi, userProfessionalInfoGetApi } from '../Model/ProfessionalModel';
import Config from '../../../../../Utility/Config';

export const userProfessionalInfoGet = (id) => {
    return get(`${Config.extendedUrl}user_professional_info/${id}`).then((response) => {
        return userProfessionalInfoGetApi(response)
    });
};


export const updateProfessionalDetailsUpdate = (data, type, id,) => {
    return patch(`${Config.extendedUrl}user_professional_info/${id}`, data).then((response) => {
        return updateProfessionalDetailsUpdateApi(response)
    });
};